// Stimulus controller registry.
//
// Mission Control colocates per-component Stimulus controllers under
// app/components/<namespace>/<name>_component/<name>_controller.js. Each
// component-side controller is registered here under its dasherised
// namespaced identifier (e.g. "system--welcome-panel" for
// System::WelcomePanelComponent). See docs/13-ui-conventions.md.

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import WelcomePanelController from "../../components/system/welcome_panel_component/welcome_panel_controller"
application.register("system--welcome-panel", WelcomePanelController)

import ModalController from "../../components/core/modal_component/modal_controller"
application.register("core--modal", ModalController)

import CoreDrawerController from "../../components/core/drawer_component/drawer_controller"
application.register("core--drawer", CoreDrawerController)

import CoreTabsController from "../../components/core/tabs_component/tabs_controller"
application.register("core--tabs", CoreTabsController)

import CoreMultiSelectController from "../../components/core/multi_select_component/multi_select_controller"
application.register("core--multi-select", CoreMultiSelectController)

import DrawerLayoutController from "../../components/drawer_layout_component/drawer_layout_controller"
application.register("drawer-layout", DrawerLayoutController)

import TagEditorController from "../../components/tasks/tag_editor_component/tag_editor_controller"
application.register("tasks--tag-editor", TagEditorController)

import CommentComposerController from "../../components/tasks/comment_composer_component/comment_composer_controller"
application.register("tasks--comment-composer", CommentComposerController)

import AttachmentsController from "../../components/tasks/attachments_region_component/attachments_controller"
application.register("tasks--attachments", AttachmentsController)

import TopNavSpaceSwitcherController from "../../components/top_nav/space_switcher_component/space_switcher_controller"
application.register("top-nav--space-switcher", TopNavSpaceSwitcherController)

import TopNavTeamSwitcherController from "../../components/top_nav/team_switcher_component/team_switcher_controller"
application.register("top-nav--team-switcher", TopNavTeamSwitcherController)

import TopNavAvatarController from "../../components/top_nav/avatar_component/avatar_controller"
application.register("top-nav--avatar", TopNavAvatarController)

import TopNavThemeSwitchController from "../../components/top_nav/theme_switch_component/theme_switch_controller"
application.register("top-nav--theme-switch", TopNavThemeSwitchController)

import TopNavSearchController from "../../components/top_nav/search_component/search_controller"
application.register("top-nav--search", TopNavSearchController)

import TopNavSearchHotkeyController from "../../components/top_nav/search_component/hotkey_controller"
application.register("top-nav--search-hotkey", TopNavSearchHotkeyController)

import DocsSidebarController from "../../components/docs/sidebar_component/sidebar_controller"
application.register("docs--sidebar", DocsSidebarController)

import DocsDndController from "../../components/docs/sidebar_component/dnd_controller"
application.register("docs--dnd", DocsDndController)

import DocsEditorController from "../../components/docs/editor_component/editor_controller"
application.register("docs--editor", DocsEditorController)

import DocsMoveDialogController from "../../components/docs/move_dialog_component/move_dialog_controller"
application.register("docs--move-dialog", DocsMoveDialogController)

import DocsSearchController from "../../components/docs/search_component/search_controller"
application.register("docs--search", DocsSearchController)

import DocsAttachmentsController from "../../components/docs/attachments_region_component/attachments_controller"
application.register("docs--attachments", DocsAttachmentsController)

import SortableStageController from "../../components/boards/column_component/sortable_stage_controller"
application.register("boards--sortable-stage", SortableStageController)

import WorkflowReorderController from "./workflow_reorder_controller"
application.register("workflows--reorder", WorkflowReorderController)

import ReorderController from "./reorder_controller"
application.register("reorder", ReorderController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import MobileStageGroupsController from "../../components/boards/show_component/mobile_stage_groups_controller"
application.register("boards--mobile-stage-groups", MobileStageGroupsController)

import CardSelectionController from "../../components/boards/show_component/card_selection_controller"
application.register("boards--card-selection", CardSelectionController)

import ContactsSearchFormController from "../../components/contacts/search_form_component/search_form_controller"
application.register("contacts--search-form", ContactsSearchFormController)

import InboundActionSelectController from "./inbound_action_select_controller"
application.register("inbound--action-select", InboundActionSelectController)

import InboundParamVisibilityController from "./inbound_param_visibility_controller"
application.register(
  "inbound--param-visibility",
  InboundParamVisibilityController
)

import CredentialGuidanceController from "./credential_guidance_controller"
application.register("credential-guidance", CredentialGuidanceController)

import WorkerVersionVendorSelectController from "./worker_version_vendor_select_controller"
application.register(
  "worker-version-vendor-select",
  WorkerVersionVendorSelectController
)

import DependencyGraphController from "../../components/tasks/dependency_graph_component/dependency_graph_controller"
application.register("tasks--dependency-graph", DependencyGraphController)

import DependencyGraphLauncherController from "../../components/tasks/dependency_graph_launcher_component/dependency_graph_launcher_controller"
application.register(
  "tasks--dependency-graph-launcher",
  DependencyGraphLauncherController
)
